import Section from '@/components/marketing/Section'

/**
 * "Prefer a direct note?" band — email, response window, and studio.
 * Rendered by the footer immediately before the CTA band on every page
 * that shows it; extracted from the contact page, the design reference.
 */
export default function DirectContactStrip() {
  return (
    <div className='border-y border-line bg-card'>
      <Section width='wide' rhythm='none'>
        <div className='grid sm:grid-cols-3'>
          <div className='flex flex-col justify-center min-h-[145px] py-7 sm:pr-7'>
            <span className='instrument-label text-muted-foreground'>
              Prefer a direct note?
            </span>
            {/* Brand blue marks this as the live action in the band; the two
                cells beside it are plain facts. Safe in both themes at this
                size: --primary is 5.36:1 on the dark card and 3.70:1 on the
                light one, and card-headline--3xl is 31.25px, so the large-text
                threshold (3.0) applies. */}
            <a
              href='mailto:founders@pixelmojo.io'
              className='card-headline card-headline--3xl min-h-11 mt-2 text-primary hover:text-cta transition-colors break-words'
            >
              founders@pixelmojo.io
            </a>
          </div>
          <div className='flex flex-col justify-center min-h-[145px] py-7 sm:px-7 border-t sm:border-t-0 sm:border-l border-line'>
            <span className='instrument-label text-muted-foreground'>
              Response window
            </span>
            <strong className='card-headline card-headline--3xl mt-2'>
              One business day
            </strong>
          </div>
          <div className='flex flex-col justify-center min-h-[145px] py-7 sm:pl-7 border-t sm:border-t-0 sm:border-l border-line'>
            <span className='instrument-label text-muted-foreground'>
              Studio
            </span>
            <strong className='card-headline card-headline--3xl mt-2'>
              Makati · Philippines
            </strong>
          </div>
        </div>
      </Section>
    </div>
  )
}
